'use strict';

module.exports = require('./Tooltip');


//////////////////
// WEBPACK FOOTER
// ./~/rc-tooltip/lib/index.js
// module id = 1030
// module chunks = 0